import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-586db622")

_pushScopeId("data-v-586db622")
const _hoisted_1 = { class: "well narrower" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", null, "Purchase a license", -1)
const _hoisted_3 = { "data-cy": "PayPortal.Paypal.Price" }
const _hoisted_4 = { "data-cy": "PayPortal.Paypal.Expiry" }
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = { class: "form-horizontal narrower" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "row" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-sm-2" }),
  /*#__PURE__*/_createVNode("div", { class: "col-sm-10" }, [
    /*#__PURE__*/_createVNode("p", null, "Please enter your country of residence below:")
  ])
], -1)
const _hoisted_8 = {
  key: 0,
  class: "required"
}
const _hoisted_9 = { "data-cy": "PayPortal.Paypal.CountryRequired" }
const _hoisted_10 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", {
  class: "form-group",
  style: {"max-width":"400px","margin":"auto"}
}, [
  /*#__PURE__*/_createVNode("p", null, "Choose one of the following payment options:"),
  /*#__PURE__*/_createVNode("div", { id: "paymentButtons" })
], -1)
_popScopeId()

import { Backend, ContentAndStudent, StudentInfo, Failure, PaypalOption, PrivateLabels, CountryRegion } from '@/modules/backend'
import { InvalidState } from '@/modules/country-region'
import { onMounted, Ref, ref, watch } from 'vue'
import { prettyDate, prettyMoney } from '@/modules/frontend'
import { loadScript } from "@paypal/paypal-js"
import CountryRegionInput from './CountryRegionInput.vue'


export default _defineComponent({
  expose: [],
  props: {
    className: { type: String, required: true },
    paypal: { type: null, required: true },
    contentAndStudent: { type: null, required: true },
    studentInfo: { type: null, required: true },
    privateLabels: { type: null, required: true },
    tenantName: { type: String, required: true }
  } as unknown as undefined,
  emits: ['other-options', 'success', 'error'],
  setup(__props: {
	className: string
	paypal: PaypalOption
	contentAndStudent: ContentAndStudent
	studentInfo: StudentInfo
	privateLabels: PrivateLabels
	tenantName: string
}, { emit }) {

const props = __props





const paypalClientId = "${PAYPAL_CLIENT_ID}"

const paypalSdkPromise = loadScript({
	"client-id": paypalClientId.startsWith("$") ? "test" : paypalClientId,
	"currency" : props.paypal.price.currency,

	// This disables pay later button.
	"disable-funding": "credit",
})

const otherOptionsButtonDisabled = ref(true)
const countryRegionDisabled = ref(false)

const countryRegion: Ref<CountryRegion | InvalidState > = ref("MissingCountry")
const showCountryRegionRequired = ref(false)

const studentInfo = ref({...props.studentInfo})

onMounted(async () => {

	try {
		const paypalSdk = await paypalSdkPromise

		if (paypalSdk?.Buttons != null) {
			await paypalSdk.Buttons({
				onInit: onPaypalButtonsInit,
				onClick: onPaypalButtonsClick,
				createOrder: createOrder,
				onApprove: completeOrder,
				onCancel: cancelOrder,
				onError: handleError,
			}).render("#paymentButtons")
		} else {
			throw "paypal-js SDK not loaded correctly."
		}

	} catch (error) {
		// TODO: Include the error as event data, and show it on error page.
		emit('error')
	}
})

function onPaypalButtonsInit(data: any, actions: any) {
	actions.disable()

	otherOptionsButtonDisabled.value = false
	
	// Disable the paypal button when the country-region input is not valid,
	// and remove the validation message when it is.
	watch(countryRegion, () => {
		if (countryRegionIsValid()) {
			actions.enable()
			showCountryRegionRequired.value = false
		} else {
			actions.disable()
		}
	})
}

function onPaypalButtonsClick() {
	showCountryRegionRequired.value = !countryRegionIsValid()
}

function countryRegionIsValid() {
	return typeof countryRegion.value == 'object'
}

async function createOrder(data: any, actions: any): Promise<string> {
	countryRegionDisabled.value = true

	if (countryRegionIsValid()) {
		const result = await Backend.createPaypalOrder(props.contentAndStudent, countryRegion.value)

		if (result instanceof Failure) {
			// TODO: Proper error handling here is unknown.
			// Throwing an exception still causes paypal button to flash the popup.
			throw "Backend error"
		}
		return result
	}
	throw "Validation error"
}

async function completeOrder(data: any, actions: any) {
	const result = await Backend.completePaypalOrder(
		data.orderID,
		studentInfo.value,
		props.privateLabels,
		props.tenantName,
		props.className
	)

	if (result instanceof Failure) {
		// TOOD: Proper error handling here is unknown.
		throw "Backend error"
	}

	emit('success')
}

async function cancelOrder(data: any) {
	countryRegionDisabled.value = false

	await Backend.cancelPaypalOrder(data.orderID)
	// TODO: Stay on page, but show message that user cancelled?
}

function handleError() {
	emit('error')
}

const missingItem = {
	"MissingCountry" : "country",
	"MissingProvince": "province",
	"MissingState": "state",
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("p", _hoisted_3, "Price: " + _toDisplayString(_unref(prettyMoney)(__props.paypal.price)), 1),
      _createVNode("p", _hoisted_4, "Expires: " + _toDisplayString(_unref(prettyDate)(__props.paypal.expiry)), 1),
      _createVNode("button", {
        disabled: otherOptionsButtonDisabled.value,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('other-options'))),
        type: "button",
        class: "btn btn-lg btn-default",
        "data-cy": "PayPortal.Paypal.OtherOptionsButton"
      }, "Other options", 8, ["disabled"])
    ]),
    _hoisted_5,
    _createVNode("div", _hoisted_6, [
      _hoisted_7,
      _createVNode(CountryRegionInput, {
        modelValue: countryRegion.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (countryRegion.value = $event)),
        disabled: countryRegionDisabled.value
      }, null, 8, ["modelValue", "disabled"]),
      (showCountryRegionRequired.value)
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            _createVNode("p", _hoisted_9, "The " + _toDisplayString(missingItem[countryRegion.value]) + " is required.", 1)
          ]))
        : _createCommentVNode("", true),
      _hoisted_10,
      _hoisted_11
    ])
  ]))
}
}

})